import { paperClasses } from '@mui/material';

export const styles = {
  root: {
    [`& .${paperClasses.root}`]: {
      height: '100%',
    },
  },
} as const;
